// <!-- 全局配置 -->
// 通过配置变量，定义页面显示的内容

// const PageType = "ContentMaker";
const PageType = "MainHome";      //MainHome 是官网页面， ContentMaker 是内容制作页面

 // 颗粒效果图的数据


const Product_Info = {
    'Origin' : {                       // 产品的关键字和后台的product_type 是一致的
        'key' : 'littlebrick',              // 产品的关键字和后台的product_type 是一致的
        'show_name' : 'Brick: Origin',
        'show_name_zh' : '积木: 像素画',
        'path' : 'Origin',
        'image_path' : require("@/assets/maindetail/pixelOrigin.jpg"),
        'particle_img' : require("@/assets/particle/brick/square-white.png"),
        'blackPart_img' : require("@/assets/particle/brick/square-black.png"),
        'particle_background_rgb' : 'rgba(50, 50, 50, 0.8)',
        'shopUrl' : "https://www.amazon.com/dp/B08TWGWRCQ",
        'board_width' : 50,
        'board_height' : 50,
    },
    'MicroBrick' : {
        'key' : 'microbrick',
        'show_name' : 'Brick: Micro',
        'show_name_zh' : '积木：微颗粒像素画',
        'path' : 'MicroBrick',
        'image_path' : require("@/assets/maindetail/microbrick.jpg"),
        'particle_img' : require("@/assets/particle/brick/square-white.png"),
        'blackPart_img' : require("@/assets/particle/brick/square-black.png"),
        'particle_background_rgb' : 'rgba(50, 50, 50, 0.8)',
        'shopUrl' : "https://www.amazon.com/dp/B08TWHLF8H",
        'board_width' : 50,
        'board_height' : 50,
    },
    'Memory' : {
        'key' : 'colorbrick_gray',
        'show_name' : 'Brick: Memory',
        'show_name_zh' : '积木：记忆',
        'path' : 'Memory',
        'image_path' : require("@/assets/maindetail/pixelMemory.jpg"),
        'particle_img' : require("@/assets/particle/brick/round-white.png"),
        'blackPart_img' : require("@/assets/particle/brick/round-black.png"),
        'particle_background_rgb' : 'rgba(50, 50, 50, 0.8)',
        'shopUrl': "https://www.amazon.com/dp/B09JVMTNF3",
        'board_width' : 16,
        'board_height' : 16,
    },
    'Energetic' : {
        'key' : 'colorbrick_orange',
        'show_name' : 'Brick: Energetic',
        'show_name_zh' : '积木：活力',
        'path' : 'Energetic',
        'image_path' : require("@/assets/maindetail/pixelEnergetic.jpg"),
        'particle_img' : require("@/assets/particle/brick/round-white.png"),
        'blackPart_img' : require("@/assets/particle/brick/round-black.png"),
        'particle_background_rgb' : 'rgba(50, 50, 50, 0.8)',
        'shopUrl': "https://www.amazon.com/dp/B09JVD66YP",
        'board_width' : 16,
        'board_height' : 16,
    },
    'Fascinatic' : {
        'key' : 'colorbrick_pink',
        'show_name' : 'Brick: Fascinatic',
        'show_name_zh' : '积木：迷人',
        'path' : 'Fascinatic',
        'image_path' : require("@/assets/maindetail/pixelFascinatic.jpg"),
        'particle_img' : require("@/assets/particle/brick/round-white.png"),
        'blackPart_img' : require("@/assets/particle/brick/round-black.png"),
        'particle_background_rgb' : 'rgba(50, 50, 50, 0.8)',
        'shopUrl': "https://www.amazon.com/dp/B09JVKX8NZ",
        'board_width' : 16,
        'board_height' : 16,
    },
    'FuseBeads' : {
        'key' : 'fusebeads',
        'show_name' : 'Fuse Beads',
        'show_name_zh' : '拼豆',
        'path' : 'FuseBeads',
        'image_path' : require("@/assets/maindetail/fusebeads.jpg"),
        'particle_img' : require("@/assets/particle/fusebeads/fusebeads-white.png"),
        'blackPart_img' : require("@/assets/particle/fusebeads/fusebeads-black.png"),
        'particle_background_rgb' : 'rgba(236, 236, 236, 0.91)',
        'shopUrl': "https://www.amazon.com/dp/B0CDLJRPNT",
        'board_width' : 29,
        'board_height' : 29,
    },
    'DiamondPainting' : {
        'key' : 'diamondpainting',
        'show_name' : 'Diamond Painting',
        'show_name_zh' : '钻石画',
        'path' : 'DiamondPainting',
        'image_path' : require("@/assets/maindetail/diamondpainting.jpg"),
        'particle_img' : require("@/assets/particle/diamond/diamond-white.png"),
        'blackPart_img' : require("@/assets/particle/diamond/diamond-black.png"),
        'particle_background_rgb' : 'rgba(50, 50, 50, 0.8)',
        'shopUrl' : "https://www.amazon.com/dp/B09G6R93JX",
        'board_width' : 160,
        'board_height' : 120,
    },
    'Romantic' : {
        'key' : 'romantic',
        'show_name' : 'Brick: Romantic',
        'show_name_zh' : '积木：浪漫',
        'path' : 'Romantic',
        'image_path' : require("@/assets/maindetail/pixelRomantic.jpg"),
        'particle_img' : require("@/assets/particle/brick/plate-round-white.png"),
        'blackPart_img' : require("@/assets/particle/brick/plate-round-black.png"), 
        'particle_background_rgb' : 'rgba(50, 50, 50, 0.8)',
        'shopUrl' : "https://www.amazon.com/dp/B0D8J2KTVB",
        'board_width' : 16,
        'board_height' : 16,
    },
    'Warmth' : {
        'key' : 'warmth',
        'show_name' : 'Brick: Warmth',
        'show_name_zh' : '积木：温暖',
        'path' : 'Warmth',
        'image_path' : require("@/assets/maindetail/pixelRomantic.jpg"),
        'particle_img' : require("@/assets/particle/brick/square-white.png"),
        'blackPart_img' : require("@/assets/particle/brick/square-black.png"), 
        'particle_background_rgb' : 'rgba(50, 50, 50, 0.8)',
        'shopUrl' : "https://www.amazon.com/dp/B0D8J2KTVB",
        'board_width' : 16,
        'board_height' : 16,
    },
}

export { PageType };
export { Product_Info };

export const default_max_width = 1080;